const place = (data) => {
	const places = data.map(
		({
			title: { rendered: title },
			link,
			acf: { adresse, telephone: phone, horaires, description, ouvertures },
		}) => {
			const address = adresse.split('\r\n')
			const opens = ouvertures.split('\r\n')

			return {
				title,
				description,
				street: address[0],
				city: address[1],
				phone,
				hours: horaires.split('\r\n'),
				opens,
				link,
			}
		},
	)

	return places.reverse()
}

export default place
